<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
    <rect class="cls-1" width="200" height="200" />
    <rect class="cls-2" x="30.75" y="154.59" width="138.51" height="28.54" />
    <polygon
      class="cls-2"
      points="30.75 16.55 30.75 45.07 121.88 100.63 30.75 100.63 30.75 129.17 169.26 129.17 169.26 100.63 77.94 44.97 30.75 16.55"
    />
  </svg>
</template>

<script>
export default {
  name: "logo"
};
</script>
<style>
.cls-1 {
  fill: none;
}

.cls-2 {
  fill: #232323;
}

svg {
  width: 100%;
}
</style>